import React from 'react';
import Logo from "../images/logo.png";
import TransparentLogo from "../images/Transparent Logo.png";
import { BoltIcon } from '@heroicons/react/24/solid';

const SmilesFlowLink = ({ isVisible, gameName = "game", theme, isPublicGame = false }) => {
  if (!isVisible) {
    return null;
  }

  // Create a clean game name for the URL (lowercase, no spaces)
  const gameNameParam = gameName?.toLowerCase().replace(/\s+/g, '-') || 'game';

  // Determine if we should use light or dark text based on background color
  const isDarkBackground = theme?.colors?.cardBackground ? 
    isColorDark(theme.colors.cardBackground) : false;
  
  const textColorClass = isDarkBackground ? "text-gray-300" : "text-gray-500";
  // Use the transparent white logo for dark backgrounds
  const logoSrc = isDarkBackground ? TransparentLogo : Logo;

  // Get the primary color from the theme, defaulting to violet-600 if not set
  const primaryColor = theme?.colors?.playAgainButton?.background || '#7C3AED';
  
  // Use retro yellow for the bolt icon to make it stand out
  const boltColor = '#F1C40F';

  return (
    <div className={`mt-6 text-center ${textColorClass} flex items-center justify-center`} style={{fontSize: '0.5rem', fontFamily: '"Share Tech Mono", monospace'}}>
      <a 
        href={isPublicGame ? "/" : `/?utm_source=game&game=${gameNameParam}`}
        className="flex items-center" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        {isPublicGame ? (
          <span className="flex items-center gap-1" style={{fontSize: '0.65rem', fontFamily: '"Share Tech Mono", monospace'}}>
            Powered by <span className="font-bold" style={{ color: primaryColor, fontFamily: '"Share Tech Mono", monospace' }}>Group Chat Heroes</span>
            <BoltIcon className="w-4 h-4" style={{ color: boltColor }} />
          </span>
        ) : (
          <>
            <span style={{ fontFamily: '"Share Tech Mono", monospace' }}>Powered by</span>
            <span className="font-bold ml-1" style={{ color: primaryColor, fontFamily: '"Share Tech Mono", monospace' }}>Group Chat Heroes</span>
            <BoltIcon className="w-4 h-4 ml-1" style={{ color: boltColor }} />
          </>
        )}
      </a>
    </div>
  );
};

// Helper function to determine if a color is dark
const isColorDark = (hexColor) => {
  // Remove the # if it exists
  hexColor = hexColor.replace('#', '');
  
  // Parse the hex values to RGB
  const r = parseInt(hexColor.substr(0, 2), 16);
  const g = parseInt(hexColor.substr(2, 2), 16);
  const b = parseInt(hexColor.substr(4, 2), 16);
  
  // Calculate the brightness (using the formula for relative luminance)
  // https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  
  // Return true if the color is dark (brightness less than 128)
  return brightness < 128;
};

export default SmilesFlowLink;